class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '6fb3f9b4';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1195.0.4';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Fri, 11 Sep 2026 14:05:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-09-11 10:05:08 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-09-11 10:05:08 Boston - 6fb3f9b4 - 1195.0.4';
export default BuildTags;
